<div class="dialog-header gbg" style="width: 600px;">
    <div class="dialog-title fs20">
       Estimate PDF
    </div>
</div>

<div class="dialog-body" style="width: 600px;" >
  <div class="row">
                            <div class="col-12">
                                <div style="width: 100%; height: 800px; border: 0 !important">
                                    <ng2-pdfjs-viewer #pdfViewer></ng2-pdfjs-viewer>
                                </div>
                            </div>
                        </div>
    <!-- <ngx-loading [show]="uloading"></ngx-loading> -->
</div>

<div class="dialog-footer text-center">
    <button mat-raised-button (click)="close()"><i class="fas fa-times"></i>&nbsp;Close</button>
</div>